// @mui
import { Card, CardActionArea, Chip, Grid } from "@mui/material";
import Iconify from "../iconify";

// ----------------------------------------------------------------------
const getTargetValueText = (questionCategory) => {
  switch (questionCategory) {
    case "SAVES":
      return "SV";
    case "GOALS_AGAINTS":
      return "GA";
    default:
      return "";
  }
};
const MatchTitle = (props) => {
  if (!props?.matchStats) {
    return <></>;
  }
  const match = props.matchStats.find(
    (match) => match?.MatchFeedId === props?.matchId
  );
  if (!match) {
    return <></>;
  }
  return (
    <Grid container sx={{ textAlign: "center" }}>
      <Grid item xs={5} sx={{ fontSize: 8 }}>
        {match.HomeTeamName}
      </Grid>
      <Grid item xs={1} sx={{ fontSize: 10 }}>
        {match.HomeTeamScore}
      </Grid>
      <Grid item xs={1} sx={{ fontSize: 10 }}>
        {match.AwayTeamScore}
      </Grid>
      <Grid item xs={5} sx={{ fontSize: 8 }}>
        {match.AwayTeamName}
      </Grid>
      <Grid item xs={12} sx={{ fontSize: 7 }}>
        {match.StartDateUtc}
      </Grid>
      <Grid item xs={12} sx={{ fontSize: 7 }}>
        {match.Status}
      </Grid>
    </Grid>
  );
};
export const MatchTeamsStats = (props) => {
  if (!props?.matchStats) {
    return <></>;
  }
  const match = props.matchStats.find((match) => {
    return match?.MatchFeedId === props?.matchId;
  });
  if (!match) {
    return <></>;
  }
  const homeTeamStats = match.MatchStats.find(
    (stat) => stat.TeamFeedId === match.HomeTeamFeedId
  );
  const awayTeamStats = match.MatchStats.find(
    (stat) => stat.TeamFeedId === match.AwayTeamFeedId
  );
  if (!homeTeamStats || !awayTeamStats) {
    return <></>;
  }
  
  return (
    <Grid container sx={{ textAlign: "left" }}>
      <Grid item xs={6}>
        Hits: {homeTeamStats.Hits}
        <br />
        Shots: {homeTeamStats.ShotsOnGoal}
        <br />
        PPG: {homeTeamStats.Goals}
        <br />
        SHG: {homeTeamStats.ShotsOnGoal}
        <br />
      </Grid>
      <Grid item xs={6} textAlign="right">
        {awayTeamStats.Hits}: Hits
        <br />
        {awayTeamStats.ShotsOnGoal} :Shots
        <br />
        {awayTeamStats.Goals} :PPG
        <br />
        {awayTeamStats.ShotsOnGoal} :SHG
        <br />
      </Grid>
    </Grid>
  );
};
export const MatchPlayerStats = (props) => {
  if (!props?.matchStats) {
    return <></>;
  }
  const match = props.matchStats.find(
    (match) => match?.MatchFeedId === props?.matchId
  );
  if (!match) {
    return <></>;
  }

  const homeTeamStats = match.MatchStats.find(
    (stat) => stat.TeamFeedId === match.HomeTeamFeedId
  );
  const awayTeamStats = match.MatchStats.find(
    (stat) => stat.TeamFeedId === match.AwayTeamFeedId
  );
  if (!homeTeamStats || !awayTeamStats) {
    return <></>;
  }
  const player = [...homeTeamStats.Players, ...awayTeamStats.Players].find(
    (player) => player.PlayerFeedId == props.playerId
  );
  if (!player) {
    return <></>;
  }

  return (
    <Grid container>
      <Grid item xs={12} sx={{ textAlign: "center", fontSize: 10 }}>
        Player Match Stats
      </Grid>
      <Grid item xs={6} sx={{ textAlign: "left" }}>
        Goals:
        <br />
        Assists:
        <br />
        SOG:
        <br />
        Saves:
        <br />
        Hits:
        <br />
        Assists:
        <br />
      </Grid>
      <Grid item xs={6} sx={{ textAlign: "right" }}>
        {player?.goals === null ? "--" : player?.goals}
        <br />
        {player?.assists === null ? "--" : player?.assists}
        <br />
        {player?.shots_on_goal === null ? "--" : player?.shots_on_goal}
        <br />
        {player?.saves === null ? "--" : player?.saves}
        <br />
        {player?.hits === null ? "--" : player?.hits}
        <br />
        {player?.assists === null ? "--" : player?.assists}
        <br />
      </Grid>
    </Grid>
  );
};

export default function OptionPreview(props) {
  const optionClickHandler = () => {
    props.optionClickHandler(props.questionId, props.option.option_id);
  };
  return (
    <>
      {props.option?.option_image ? (
        <Card
          sx={{
            maxWidth: 110,
            background: "#262626",
            color: "#ffffff",
            position: "relative",
            border:
              props.option?.is_correct && props.option.is_correct
                ? "3px solid #5DB661"
                : props.option?.isSelected && props.option.isSelected
                ? "3px solid #FFA726"
                : "none",
          }}
        >
          {props.option?.is_correct && props.option.is_correct ? (
            <Iconify
              icon="eva:checkmark-outline"
              sx={{
                transform: "scale(3)",
                top: -20,
                right: -15,
                position: "absolute",
                cursor: "pointer",
                margin: 3,
                color: "green",
              }}
            />
          ) : null}
          <CardActionArea
            onClick={() => optionClickHandler()}
            sx={{ padding: 1 }}
          >
            <Grid
              container
              style={{ textAlign: "center", padding: 5 }}
              spacing={1}
            >
              {props.option?.is_correct &&
              props.option.is_correct &&
              props.option?.isSelected &&
              props.option.isSelected ? (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    width: 30,
                  }}
                >
                  <img src="/assets/icons/correct-icon.png" />
                </div>
              ) : null}

              {!props.option.is_correct &&
              props.option?.isSelected &&
              props.option.isSelected ? (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    width: 30,
                  }}
                >
                  <img src="/assets/icons/incorrect-icon.png" />
                </div>
              ) : null}

              <div
                style={{ position: "absolute", right: 10, top: 10, width: 30 }}
              >
                <img src={props.option.option_secondary_image} />
              </div>
              {props.option?.data?.opp_name ? (
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 115,
                    width: 138,
                    background: "#fff",
                    borderTopRightRadius: 20,
                    padding: "5px 5px",
                    textAlign: "left",
                    color: "#000",
                    fontSize: 10,
                  }}
                >
                  vs {props.option?.data?.opp_name}
                </div>
              ) : null}

              {props.option?.data?.jersey_number ? (
                <div
                  style={{ position: "absolute", left: 10, top: 10, width: 20 }}
                >
                  #{props.option?.data?.jersey_number}
                </div>
              ) : null}

              <Grid item xs={12}>
                <img src={props.option.option_image} />
              </Grid>
              {props.option?.opp_name ? (
                <Grid item xs={12}>
                  VS {props.option.opp_name}
                </Grid>
              ) : null}
              <Grid item xs={12} style={{ fontSize: 12, fontWeight: "bold" }}>
                {props.lang
                  ? props.option[`title_` + props.lang]
                  : props.option.title_en}
              </Grid>
              <Grid
                item
                xs={12}
                style={{ fontSize: 12, fontWeight: "bold", color: "#16D490" }}
              >
                {props.lang
                  ? props.option["description_" + props.lang]
                  : props.option.description_en}
              </Grid>

              <Grid item xs={12}>
                <img
                  src={props.option.option_sponsor_image}
                  style={{ margin: "0 auto" }}
                />
              </Grid>

              <Grid item xs={12}>
                {props.option.sponsor_odds}
              </Grid>
              {props.option?.hot_cold_label_en ? (
                <Grid
                  item
                  xs={12}
                  style={{
                    background: "#323232",
                    color: "#fff",
                    borderRadius: 10,
                    padding: 5,
                    marginTop: 10,
                  }}
                >
                  <img
                    src={"/assets/icons/snowflake.png"}
                    style={{ float: "left" }}
                  />

                  {props.lang
                    ? props.option["hot_cold_label_" + props.lang]
                    : props.option.hot_cold_label_en}
                </Grid>
              ) : null}
              {props.option?.data?.target_score ? (
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={6}>
                      {props.option?.data?.target_score}{" "}
                      {getTargetValueText(props.question?.category)}
                    </Grid>
                    <Grid item xs={6}></Grid>
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </CardActionArea>
        </Card>
      ) : (
        <Chip
          onClick={() => optionClickHandler()}
          sx={{
            m: 1,
            border:
              props.option?.is_correct && props.option.is_correct
                ? "3px solid #5DB661"
                : props.option?.isSelected && props.option.isSelected
                ? "3px solid #FFA726"
                : "none",
          }}
          label={
            props.lang
              ? props.option["title_" + props.lang]
              : props.option.title_en
          }
        />
      )}
      {props.option?.data?.match_id && props.matchStats !== null && (
        <Grid container sx={{ mt: 2, maxWidth: 150 }}>
          <Grid item xs={12} sx={{ fontSize: 9 }}>
            <MatchTitle
              matchId={props.option?.data?.match_id}
              matchStats={props.matchStats}
            />
          </Grid>
          <Grid item xs={12}>
            {props.option?.data?.player_id &&
            props.option?.data?.player_id !== null ? (
              <MatchPlayerStats
                matchId={props.option?.data?.match_id}
                playerId={props.option?.data?.player_id}
                matchStats={props.matchStats}
              />
            ) : (
              <MatchTeamsStats
                matchId={props.option?.data?.match_id}
                matchStats={props.matchStats}
              />
            )}
          </Grid>
        </Grid>
      )}
    </>
  );
}
